import { instance } from "./instance";
import { theme as defaultTheme } from "./defaultTheme";
type InstanceConfig = {
    title: string;
    background?: {
        light?: string;
        dark?: string;
        solid?: string;
    }
    redirectToProd?: string;
    store?: {
        productGrid?: string[];
    }
    callApp?: {
        napDocLink?: string;
    };
    theme?: any;
    companyName?: string;
    instanceName?: string;
    favicon?: string;
    privacyPolicyUrl?: string;
    termsUrl?: string;
    pwaName?: string;
    pwaShortName?: string;
    pwaDescription?: string;
    pwaThemeColor?: string;
    pwaBackgroundColor?: string;
    pwaIcon192Maskable?: string;
    pwaIcon512Maskable?: string;
    pwaIcon512?: string;
    onboardingVideos?: Record<string, string>;
}

const defaultInstanceConfig: InstanceConfig = {
    title: "APP DEFAULT TITLE",
}

const {theme, ...instanceConfig} = instance;

export const INSTANCE_CONFIG = {
    ...defaultInstanceConfig,
    ...instanceConfig,
    theme: {
        ...defaultTheme,
        token: {
            ...defaultTheme.token,
            ...theme,
        }
    }
}

//console.log("INSTANCE_CONFIG", INSTANCE_CONFIG);